import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';

import { AuthShell } from '../../components/admin/AuthShell';
import { Button, Input } from '../../components/ui';
import { api } from '../../lib/api';

export function AdminForgotPage() {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);

  async function onSubmit(e: FormEvent): Promise<void> {
    e.preventDefault();
    try {
      await api.post('/admin/auth/forgot', { email });
    } finally {
      setDone(true);
    }
  }

  return (
    <AuthShell
      title="Reset your password"
      subtitle="Enter your email and we'll send a reset link."
      footer={
        <Link to="/admin/login" className="text-navy-900 underline">
          Back to sign in
        </Link>
      }
    >
      {done ? (
        <p>If that email exists, a reset link is on its way.</p>
      ) : (
        <form onSubmit={onSubmit} className="space-y-4">
          <Input type="email" label="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          <Button type="submit" className="w-full">
            Send reset link
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
